import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { cx } from '@milanote/roma/utils/cx';

const SEMANTIC_NAME = 'RomaSurface';

export type SurfaceType = 'light' | 'dark';
type SurfaceClassName = 'light-surface' | 'dark-surface';

type SurfaceContextType = SurfaceClassName | null;

export const SurfaceContext = createContext<SurfaceContextType>(null);

export const useSurface = (): SurfaceContextType => {
    return useContext(SurfaceContext);
};

const getSurfaceClassName = (surface: SurfaceType): SurfaceClassName => {
    return `${surface}-surface` as SurfaceClassName;
};

type SurfaceProps = {
    surface: SurfaceType;
    className?: string;
    children: ReactNode;
};

export const Surface = ({ surface, className, children }: SurfaceProps) => {
    const surfaceClassName = getSurfaceClassName(surface);

    return (
        <SurfaceContext.Provider value={surfaceClassName}>
            <div className={cx(SEMANTIC_NAME, 'contents', surfaceClassName, className)}>{children}</div>
        </SurfaceContext.Provider>
    );
};

Surface.displayName = SEMANTIC_NAME;
